import styled from 'styled-components';
import AppBar from '@material-ui/core/AppBar';

const Footer = styled(AppBar)`
  bottom: 0;
  top: initial !important;
`;

export default Footer;
